/* ==========================================================================
   Burly — carousel.js
   Generic horizontal scroll-snap carousel controller. Pairs with any
   [data-carousel] track plus sibling [data-carousel-prev] / [data-carousel-next]
   buttons inside the same section. Arrow clicks page by one full container
   width (e.g. 3 cards on desktop, 1 on mobile); native touch/trackpad swipe
   works on the track directly since it's a real scroll container.
   ========================================================================== */

(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(track) {
    const section = track.closest('.section') || track.parentElement;
    const prevButton = section.querySelector('[data-carousel-prev]');
    const nextButton = section.querySelector('[data-carousel-next]');
    if (!prevButton && !nextButton) return;

    function updateButtons() {
      const max = track.scrollWidth - track.clientWidth;
      if (prevButton) prevButton.disabled = track.scrollLeft <= 4;
      if (nextButton) nextButton.disabled = track.scrollLeft >= max - 4;
    }

    function page(direction) {
      track.scrollBy({
        left: direction * track.clientWidth,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    if (prevButton) prevButton.addEventListener('click', () => page(-1));
    if (nextButton) nextButton.addEventListener('click', () => page(1));

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  document.querySelectorAll('[data-carousel]').forEach(initCarousel);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-carousel]').forEach(initCarousel);
  });
})();
